import { stringify } from 'query-string';

export default (path, params) => (req = {}) => {
  const { args = {} } = req;
  return `${path}?${stringify({ ...args, ...params })}`;
};
